import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocationPackageForm from './LocationPackageForm'

const LocationPackageEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.locationpackages.editPackage'}>
      <Edit>
        <LocationPackageForm />
      </Edit>
    </SectionWrapper>
  )
}

export default LocationPackageEdit
